/* eslint-disable import/order */
import { userSegRedirectEntrypoint } from '@jira/redirect-entrypoints__user-seg-redirect/src/userSegRedirectEntrypoint.entrypoint.tsx';
import { businessCapacityParentEntryPoint } from '@jira/spa-apps__business-capacity/src/businessCapacityParentEntryPoint.entrypoint.tsx';
import { MenuIdProjects } from '@jira/navigation-apps__constants/src/MenuIdProjects.tsx';
// eslint-disable-next-line jira/import/no-restricted-import
import { getProjectViewResources } from '@jira/router-resources__business-common/src/getBusinessProjectResources.tsx';
import { AsyncHorizontalNavJira } from '@jira/navigation-apps__horizontal-nav-jira/src/async.tsx';
// eslint-disable-next-line jira/import/no-restricted-import
import { businessProjectLayout } from '@jira/platform__layouts-business-project-layout/src/index.tsx';
import { embeddedIssuePreloadLayoutBuilder } from '@jira/platform__layouts-issue-preload-layout/src/index.tsx';
import { getIssueViewResources } from '@jira/router-resources__issue-view/src/getIssueViewResources.tsx';
import { ThemedLazySkeleton } from '@jira/platform__project-theme-components/src/ui/ThemedLazySkeleton.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { composeLayouts } from '@jira/platform__layouts-route-layout/src/GlobalComponent.tsx';
import { jiraSpaResources } from '@jira/router-resources__spa-page-container/src/jiraSpaResources.tsx';
import { jiraBusinessCapacityRoute } from '@jira/router-routes__business-capacity-routes/src/jiraBusinessCapacityRoute.tsx';
import { createPageEntryPoint } from '@jira/platform__routing-create-route-entry-point/src/index.tsx';
import { jiraHorizontalNavEntrypoint } from '@jira/navigation-apps__horizontal-nav-jira/src/jiraHorizontalNavEntrypoint.entrypoint.tsx';
import type { Route } from '@atlassian/react-resource-router';

const businessCapacityPageEntrypoint = createPageEntryPoint({
	main: businessCapacityParentEntryPoint,
	horizontalNavigation: jiraHorizontalNavEntrypoint,
	redirect: userSegRedirectEntrypoint,
});

export const jiraBusinessCapacityRouteEntry: Route = createEntry(jiraBusinessCapacityRoute, () => ({
	group: 'classic-business',
	ufoName: 'jwm.jwm-capacity',

	layout: composeLayouts(
		businessProjectLayout,
		embeddedIssuePreloadLayoutBuilder([{ query: ['selectedIssue'] }]),
	),

	skeleton: ThemedLazySkeleton,

	navigation: {
		menuId: MenuIdProjects,
		horizontal: AsyncHorizontalNavJira,
	},

	resources: [...jiraSpaResources(), ...getIssueViewResources(), ...getProjectViewResources()],

	entryPoint: () => {
		if (__SERVER__) {
			return undefined;
		}
		return businessCapacityPageEntrypoint;
	},
	supportsPreviewPanel: true,
	supportsProjectTheme: 'contoured',

	bifrost: {
		bifrostGroup: 'shell-only',
	},
}));
